<template>
  <div class="allorder">
    <div class="condition_box">
      <div class="time_choose">
        <span style="margin-right: 20px">{{ $t("other.a2839") }}</span>
        <el-date-picker
          v-model="timeValue"
          type="datetimerange"
          size="small"
          value-format="yyyy-MM-dd"
          @change="gerOrder"
          :picker-options="pickerOptions2"
          :range-separator="rangeseparator"
          :start-placeholder="startplaceholder"
          :end-placeholder="endplaceholder"
          align="right"
        >
        </el-date-picker>
      </div>
      <div class="nav">
        <div class="navLi">
          <img src="../../../../assets/img/tj1.png" alt="" />
          <div class="navContent">
            <div>{{distributionUsersNum}}</div>
            <div>{{ $t("other.a3315") }}</div>
          </div>
        </div>
        <div class="navLi">
          <img src="../../../../assets/img/tj2.png" alt="" />
          <div class="navContent">
            <div>￥{{totalGonghuo.toFixed(2)}}</div>
            <div>{{ $t("other.a3316") }}</div>
          </div>
        </div>
        <div class="navLi">
          <img src="../../../../assets/img/tj3.png" alt="" />
          <div class="navContent">
            <div>￥{{totalYongjin.toFixed(2)}}</div>
            <div>{{ $t("other.a3317") }}</div>
          </div>
        </div>
      </div>
      <div class="store_header">
        <div class="pomog">
          <el-input
            size="mini"
            style="width: 250px"
            v-model="input"
            :placeholder="$t('other.a3318')"
            clearable
          ></el-input>
          <el-select
            size="mini"
            style="width: 160px; margin-right: 3px"
            v-model="value"
            :placeholder="$t('other.a3319')"
            clearable
            @change="search"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            size="mini"
            style="margin-left: 5px"
            type="primary"
            @click="search()"
            >{{ $t("other.a245") }}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="userId" :label="$t('other.a3320')"> </el-table-column>
        <el-table-column prop="level" :label="$t('other.a3319')"> 
          <template slot-scope="props">
            {{ props.row.level == 1?$t('other.a3321'):props.row.level == 2?$t('other.a3322'):$t('other.a3323') }}
          </template>
        </el-table-column>
        <el-table-column prop="totlePurchase" :label="$t('other.a3324')"> 
          <template slot-scope="props">
            {{ props.row.totlePurchase.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="totalCommission" :label="$t('other.a3325')">
          <template slot-scope="props">
            {{ props.row.totalCommission.toFixed(2) }}
          </template>
         </el-table-column>
        <el-table-column :label="$t('other.a33')"><el-button type="primary">{{$t('other.a3326')}}</el-button></el-table-column>
      </el-table>
    </div>
  </div>
</template>
  
  <script>
import { mapState, mapActions, mapMutations } from "vuex";
import api from "../../../../api/api";
import orderApi from "../../../../api/moudles/order";
import Condition from "../../../../components/condition";
import utils from "../../../../utils/utils.js";
import userStoreItems from "../../../../api/moudles/userStoreItems";
import newOrdersApi from "@/api/moudles/newOrders";
export default {
  data() {
    return {
      input:'',
      value:'',
      options: [
        {
          label: this.$t('other.a3321'),
          value: 1,
        },
        {
          label: this.$t('other.a3322'),
          value: 2,
        },
        {
          label: this.$t('other.a3323'),
          value: 3,
        },
      ],
      rangeseparator: this.$t("allorders.until"),
      startplaceholder: this.$t("allorders.starttime"),
      endplaceholder: this.$t("allorders.endtime"),
      type: 0,
      shophasAuthorization: JSON.parse(
        localStorage.getItem("shophasAuthorization")
      ),
      timeValue: [],
      pickerOptions2: {
        shortcuts: [
          {
            text: this.$t("allorders.latestweek"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("allorders.Lastmonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("allorders.Lastthreemonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      params: {
        endTime: null,
        startTime: null,
        userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      },
      tableData: [],
      oldtableData:[],
      distributionUsersNum:0,
      totalGonghuo:0,
      totalYongjin:0
    };
  },
  components: {
    Condition,
  },
  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
      pendingorderCounts: (state) => state.order.pendingorderCounts,
      unprocessedorderCounts: (state) => state.order.unprocessedorderCounts,
    }),
    shippedorder() {
      return this.$t("shippedorder");
    },
    totalCount() {
      if (this.orderstatus === 0) {
        return this.allCount;
      } else if (this.orderstatus === 1) {
        return this.pendingorderCounts;
      } else if (this.orderstatus === 3) {
        return this.unprocessedorderCounts;
      } else if (this.orderstatus === 4) {
        return this.unprocessedorderCounts;
      } else if (this.orderstatus === 5) {
        return this.unprocessedorderCounts;
      }
    },
  },
  created() {
    console.log(8888)
    this.init();
  },
  methods: {
    ...mapActions("order", [
      "getAllorder",
      "getOrdersBytrickNo",
      "getGoodsOrder",
    ]),
    queryAllOrder(params) {
      console.log('-=-=-=-=-=-=')
      console.log(params);
      userStoreItems.getDiscount(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.distributionUsersNum = res.data.distributionUsersNum
          this.totalGonghuo = res.data.totalGonghuo
          this.totalYongjin = res.data.totalYongjin
          this.tableData = res.data.distributionCommissionList;
          this.oldtableData = JSON.parse(JSON.stringify(this.tableData))
        }
      });
    },
    search() {
      let arr = JSON.parse(JSON.stringify(this.oldtableData))
      let arrData = []
      for(let i = 0;i<arr.length;i++){
        console.log(arr[i])
        if(arr[i].userId.indexOf(this.input)!=-1){
          if(this.value){
            if(arr[i].level==this.value){
              arrData.push(arr[i])
            }
          }else{
            arrData.push(arr[i])
          }
        }
      }
      this.tableData = arrData
      // this.queryAllOrder(this.params);
    },
    gerOrder() {
      this.params.startTime = this.timeValue[0];
      this.params.endTime = utils.CurdateAddoneday(this.timeValue[1]);
      this.queryAllOrder(this.params);
    },

    init() {
      // if (!this.shophasAuthorization) {
      //   return;
      // }

      this.timeValue = [
        utils.getRecentSevenDay(-30),
        utils.getRecentSevenDay(1),
      ];
      this.params.startTime = this.timeValue[0]
      this.params.endTime = this.timeValue[1]
      this.queryAllOrder(this.params);
    },

    getStatus(item) {
      const params = {
        0: this.$t("other.a730"),
        1: this.$t("other.a2841"),
        2: this.$t("other.a2842"),
        3: this.$t("other.a926"),
        4: this.$t("other.a119"),
      };
      let ttp = null;
      ttp = params[item];
      return ttp;
    },
    getTime(item) {
      return utils.renderTime(item);
    },
  },
};
</script>
  
  <style >
.title-enter-active {
  transition: all 0.3s ease;
}

.title-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.title-enter, .title-leave-to
      /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: scale(0.5);
  /* opacity: 0; */
}

.allorder {
  /* flex: 1;
          margin: 60px 0 0 235px; */
}

.allorder .time_choose {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}
.allorder .nav {
  display: flex;
  margin-bottom: 20px;
}
.allorder .nav .navLi {
  width: 320px;
  height: 160px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-right: 40px;
  display: flex;
  align-items: center;
  padding: 0px 30px;
  border-radius: 10px;
}
.allorder .nav .navLi img {
  width: 60px;
  height: 60px;
  background-color: #f3f3f3;
  border-radius: 50%;
  margin-right: 10px;
}
.allorder .nav .navLi .navContent {
  font-weight: bold;
}
.allorder .nav .navLi .navContent div:nth-child(1) {
  font-size: 36px;
}
</style>